import { normalizeUrl } from "./url";
let docCache;
let docDeps = [];
const getDocCache = (data, base, getCollection) => {
    if (docDeps.every((d) => d === data || d === base)) {
        docDeps = [data, base];
        docCache = getCollection();
    }
    return docCache;
};
export const getDocCollection = (data) => {
    const base = data.site?.siteMetadata?.avaDocsBase;
    return getDocCache(data, base, () => {
        const nodes = data.allMdx.nodes || [];
        return nodes.reduce((acc, node) => {
            if (!node.askAva)
                return acc;
            const { slug, prefix } = node.askAva;
            let path = node.askAvaPath;
            const { category = "", subCategory = "", title = "", } = node.frontmatter || {};
            path = normalizeUrl([base, path].join("/"));
            if (!title || !slug)
                return acc;
            const docMeta = {
                id: node.id,
                title,
                path,
                slug,
            };
            if (!category || !subCategory || !title)
                return acc;
            const prefixIndex = acc.catIndex[prefix] = (acc.catIndex[prefix] || {});
            const orderedCategories = acc.orderedCategories[prefix] = (acc.orderedCategories[prefix] || []);
            const hasCat = category in prefixIndex;
            const catIndex = prefixIndex[category] = (prefixIndex[category] || {
                cat: {
                    category,
                    firstDoc: path,
                    subCategories: [],
                },
                subs: {},
            });
            const hasSubcat = subCategory in catIndex.subs;
            const subDocs = catIndex.subs[subCategory] = (catIndex.subs[subCategory] || []);
            if (!hasCat)
                orderedCategories.push(catIndex.cat);
            if (!hasSubcat)
                catIndex.cat.subCategories.push({
                    subCategory,
                    firstDoc: path,
                    docs: subDocs,
                });
            subDocs.push(docMeta);
            acc.docs.push(docMeta);
            return acc;
        }, {
            base,
            docs: [],
            orderedCategories: {},
            catIndex: {},
        });
    });
};
export const createMdxBaseRoutes = (input) => (input);
